/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

/* Ott-common */
import InteractiveElement from '@dtvgo/interactive-element';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';
import { noOp } from '../../utils/functions';

/* Styles */
import './SeeAllCardVod.scss';

function SeeAllCard({
  focused,
  className,
  onMouseEnter,
  onMouseDown,
}) {
  return (
    <InteractiveElement
      className={`dtv-html5-c-see-all-card ${
        focused ? 'dtv-html5-c-see-all-card--focused' : ''
      } ${className}`}
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
    >
      <FormattedMessage id="seeAll.title" />
    </InteractiveElement>
  );
}

SeeAllCard.propTypes = {
  focused: PropTypes.bool.isRequired,
  className: PropTypes.string,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
};

SeeAllCard.defaultProps = {
  className: '',
  onMouseDown: noOp,
  onMouseEnter: noOp,
};

export default memo(withInteractiveFocusable()(memo(SeeAllCard)));
